<!-- @if(!isTypeSelected) {
<div class="app__solid--border w-[740px] h-auto relative rounded-xl bg-white border-[#e2e4e5]">
  <div class="h-[62px] py-[16px] px-[24px] w-full flex justify-between bg-[#FFF] rounded-t-xl rounded-b-none border-b border-[#53565b38]">
    <div class="font-bold font-open-sans text-[#010B18] text-xl">Select Vault Type</div>
    <div class="h-[24px] w-[24px] flex-center">
      <button class="hover:cursor-pointer bg-transparent" matTooltipPosition="above" data-dismiss="modal" (click)="closeDialog()">
        <span class="material-icons text-[#313131] text-[24px] leading-7">clear</span>
      </button>
    </div>
  </div>

  <div class="app__centered-item flex-wrap gap-4 mt-[24px] mb-[24px]">
    <div
      *ngFor="let item of vaultConfigurationList; let i = $index"
      class="app__discovery--rectangular--options relative w-[220px] h-[200px] sm:w-[220px] sm:h-[200px] cy-select-vault-{{ item.type }}"
      [ngClass]="{
        ' bg-[#EFFFF7] border-[#1AA140] border-[2px]': item.isSelected,
        ' hover:rounded-xl hover:bg-[#EFFFF7] hover:border-[2px] hover:border-[#1AA140] hover:cursor-pointer': !item.isSelected
      }"
      (click)="selectVaultType(item)"
    >
      <div class="hover:cursor-pointer pt-[50px] pb-[26px]" style="display: flex; flex-direction: column; align-items: center">
        <div class="w-[68px] h-[68px] flex-center">
          <img src="assets/images/discovery/selected.svg" *ngIf="item.isSelected" class="h-[68px] w-[68px]" />
          <img
            class="h-[68px] w-[68px]"
            [src]="item?.type ? '../../../../../../assets/images/vault/' + item?.type + '.svg' : '../../../../../../assets/images/shared.svg'"
            *ngIf="!item.isSelected"
          />
        </div>

        <div class="mt-[8px] h-[48px] text-[#1E1E20] text-base font-semibold font-open-sans">{{ item?.label | truncateStrPipe : 20 }}</div>
      </div>
    </div>
    @if(user_type == 'Professional'){

    <div class="form-group form-main form-group-overrides w-full mb-0 px-[24px]">
      <p style="margin: 0px !important ; padding: 0px !important" class="text-[#1E1E20] text-base font-semibold">Who should own this vault?</p>

      @if(showSearchConnection){
      <div class="div-group w-full" style="display: flex; justify-content: center; align-items: center">
        <div class="w-full" *ngIf="allUserConnections && allUserConnections?.length > 0">
          <manage-users
            [data]="allUserConnections"
            placeHolder="Search Connections"
            (selectConnectedUser)="selectConnectedUser($event)"
            [selectedUsers]="nonProfessionalUsers"
            [isBalanceSheetMember]="true"
            [userType]="user_type"
            [isShowFooter]="isShowFooter"
            [isInputFullWidth]="true"
          ></manage-users>
        </div>
      </div>

      }@else{
      <button
        (click)="showSearchConnection = true"
        style="width: 100%; margin-top: 16px; margin-bottom: 16px"
        class="text-[#25508E] bg-transparent flex justify-between border border-[#B1ACB066] rounded p-3"
      >
        <span>
          {{
            professionalVaultCreator
              ? professionalVaultCreator?.name
                ? professionalVaultCreator?.name
                : professionalVaultCreator?.user_first_name + ' ' + professionalVaultCreator?.user_last_name
              : 'Select'
          }}</span
        >
        <mat-icon style="transform: rotate(90deg)">chevron_right</mat-icon>
      </button>

      }
    </div>
    }
  </div>
  <div class="border-t border-[#53565b38] h-[56px] py-[12px] px-[24px] w-full fl-justify-end flex">
    <button
      class="continue-btn cy-select-vault-type-btn"
      [class.disable-button-continue-light]="user_type == 'Professional' ? !professionalVaultCreator || !selectedVaultType : !selectedVaultType"
      [disabled]="user_type == 'Professional' ? !professionalVaultCreator || !selectedVaultType : !selectedVaultType"
      (click)="isTypeSelected = true; addLoginLUser()"
    >
      Continue
    </button>
  </div>
</div>
} @if(isTypeSelected) {
<div class="app__solid--border w-[750px] h-[600px] relative rounded-xl bg-white border-[#e2e4e5]">
  <div class="dialog-close">
    <button mat-icon-button title="Close" class="app__close--icon p-0 h-[32px] w-[32px]" (click)="closeDialog()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  @if (!is_entity_creation_suggestion && (steps && steps.length) && selectedVaultType =='entity' ) {
  <div>
    <div class="stepper-container">
      <div
        class="stepper-container-item"
        *ngFor="let item of steps; let i = index"
        [ngStyle]="{ background: i < this.step ? '#7E9BD4' : i === this.step ? '#25508E' : '#DCDCDC' }"
      ></div>
    </div>
  </div>
  }

  <div class="header-container">{{ steps[step].stepLabel }}</div>

  <div style="padding: 0px 60px">
    @if(steps[step].stepType === 'member') {
    <div>
      <vault-setup-members
        [vaultMembers]="vaultMembers"
        [professionalVaultCreator]="professionalVaultCreator"
        (setVaultMember)="setVaultMember($event)"
        [isFromVault]="true"
      ></vault-setup-members>
    </div>
    } @if(steps[step].stepType === 'admin') {
    <div>
      <vault-setup-admin
        [vaultAdmins]="vaultAdmins"
        (setVaultAdmins)="setVaultAdmins($event)"
        [isFromVault]="true"
        [stepInfo]="stepInfo"
        [selectedIndex]="selectedIndex"
        [selectedVaultType]="selectedVaultTypeInfo"
      ></vault-setup-admin>
    </div>
    } @if(steps[step].stepType === 'sharing') {
    <div>
      <vault-setup-sharing
        [vaultSharing]="vaultSharing"
        (setVaultSharing)="setVaultSharing($event)"
        [isFromVault]="true"
        [stepInfo]="stepInfo"
        [selectedIndex]="selectedIndex"
        [selectedVaultType]="selectedVaultTypeInfo"
      ></vault-setup-sharing>
    </div>
    } @if(steps[step].stepType === 'name') {
    <add-entity-vault
      [forms]="forms"
      [isFromVault]="true"
      [setEntityTypeSuggestion]="setEntityTypeSuggestion"
      [setEntityNameSuggestion]="setEntityNameSuggestion"
      (setEntityType)="setEntityType($event)"
      (setEntityName)="setEntityName($event)"
    ></add-entity-vault>
    }
  </div>

  <div class="absolute h-[66px] w-[687px] bottom-[24px] ml-[32px] border-t border-[#C1C2C5] pt-[24px]">
    <div
      class="w-full flex"
      [ngClass]="{
        'fl-justify-between': step > 0,
        'fl-justify-end': step == 0
      }"
    >      <button *ngIf="step > 0" type="button" class="footer-back-btn" (click)="changeStep(-1)">
        <i class="material-icons back-arrow h-[16px] w-[16px] text-[16px]">arrow_back</i> Back
      </button>
      <button
        class="footer-continue-btn cy-vault-next-btn"
        [class.disable-button-continue-light]="this.selectedVaultType === 'entity' && (!entityName || !selectedEntityType)"
        [disabled]="this.selectedVaultType === 'entity' && (!entityName || !selectedEntityType)"
        (click)="changeStep(1)"
      >
        {{ is_entity_creation_suggestion ? 'Save' : 'Continue' }}
      </button>
    </div>
  </div>
</div>
@if (formData?.length) {
<div style="display: none">
  <edit-template-basic-form [Form1]="formData" [documentForm]="documentForm"> </edit-template-basic-form>
</div>
} } -->

@if(!isTypeSelected) {
<div class="app__solid--border w-[504px] h-auto relative rounded-xl bg-white border-[#e2e4e5]">
  <div class="h-[62px] py-[16px] px-[24px] w-full flex justify-between bg-[#FFF] rounded-t-xl rounded-b-none border-b border-[#53565b38]">
    <div class="font-bold font-open-sans text-[#010B18] text-xl">Select Vault Type</div>
    <div class="h-[24px] w-[24px] flex-center">
      <button class="hover:cursor-pointer bg-transparent" matTooltipPosition="above" data-dismiss="modal" (click)="closeDialog()">
        <span class="material-icons text-[#313131] text-[24px] leading-7">clear</span>
      </button>
    </div>
  </div>

  <div class="app__centered-item flex-wrap gap-4 mt-[24px] mb-[24px]">
    <div
      *ngFor="let item of vaultConfigurationList; let i = $index"
      class="app__discovery--rectangular--options relative w-[220px] h-[200px] sm:w-[220px] sm:h-[200px] cy-select-vault-{{ item.type }}"
      [ngClass]="{
        ' bg-[#EFFFF7] border-[#1AA140] border-[2px]': item.isSelected,
        ' hover:rounded-xl hover:bg-[#EFFFF7] hover:border-[2px] hover:border-[#1AA140] hover:cursor-pointer': !item.isSelected
      }"
      (click)="selectVaultType(item)"
    >
      <div class="hover:cursor-pointer pt-[50px] pb-[26px]" style="display: flex; flex-direction: column; align-items: center">
        <div class="w-[68px] h-[68px] flex-center">
          <img src="assets/images/discovery/selected.svg" *ngIf="item.isSelected" class="h-[68px] w-[68px]" />
          <img class="h-[68px] w-[68px]" [src]="'/assets/images/vault/' + item?.type + '.svg'" *ngIf="!item.isSelected" />
        </div>

        <div class="mt-[8px] h-[48px] text-[#1E1E20] text-base font-semibold font-open-sans">{{ item?.label | truncateStrPipe : 20 }}</div>
      </div>
    </div>
    @if(user_type == 'Professional'){

    <div class="form-group form-main form-group-overrides w-full mb-0 px-[24px]">
      <p style="margin: 0px !important ; padding: 0px !important" class="text-[#1E1E20] text-base font-semibold">Who should own this vault?</p>

      @if(showSearchConnection){
      <div class="div-group w-full" style="display: flex; justify-content: center; align-items: center">
        <div class="w-full" *ngIf="allUserConnections && allUserConnections?.length > 0">
          <manage-users
            [data]="allUserConnections"
            placeHolder="Search Connections"
            (selectConnectedUser)="selectConnectedUser($event)"
            [selectedUsers]="nonProfessionalUsers"
            [isBalanceSheetMember]="true"
            [userType]="user_type"
            [isShowFooter]="isShowFooter"
            [isInputFullWidth]="true"
          ></manage-users>
        </div>
      </div>

      }@else{
      <button
        (click)="showSearchConnection = true"
        style="width: 100%; margin-top: 16px; margin-bottom: 16px"
        class="text-[#25508E] bg-transparent flex justify-between border border-[#B1ACB066] rounded p-3"
      >
        <span>
          {{
            professionalVaultCreator
              ? professionalVaultCreator?.name
                ? professionalVaultCreator?.name
                : professionalVaultCreator?.user_first_name + ' ' + professionalVaultCreator?.user_last_name
              : 'Select'
          }}</span
        >
        <mat-icon style="transform: rotate(90deg)">chevron_right</mat-icon>
      </button>

      }
    </div>
    }
  </div>
  <!-- <div class="border-t border-[#53565b38] h-[56px] py-[12px] px-[24px] w-full fl-justify-end flex">
      <button
        class="continue-btn cy-select-vault-type-btn"
        [class.disable-button-continue-light]="user_type == 'Professional' ? !professionalVaultCreator || !selectedVaultType : !selectedVaultType"
        [disabled]="user_type == 'Professional' ? !professionalVaultCreator || !selectedVaultType : !selectedVaultType"
        (click)="isTypeSelected = true; addLoginLUser()"
      >
        Continue
      </button>
    </div> -->
</div>
} @if(isTypeSelected) {
<div class="app__solid--border w-[750px] h-[600px] relative rounded-xl bg-white border-[#e2e4e5]">
  <div class="absolute top-[42px] right-[42px]">
    <button mat-icon-button title="Close" class="app__close--icon p-0 h-[32px] w-[32px]" (click)="closeDialog()">
      <mat-icon class="text-[#B1ACB0]">close</mat-icon>
    </button>
  </div>

  @if (!is_entity_creation_suggestion && (steps && steps.length) && selectedVaultType =='entity' ) {
  <div>
    <div class="flex flex-row justify-center w-full px-[60px] pt-[42px] pb-0 max-[480px]:pt-[12px] max-[345px]:w-[90%]">
      <div
        class="w-[70px] h-[6px] rounded-[40px] mr-[8px] max-[480px]:w-[65px] max-[345px]:w-[60px] max-[345px]:mr-[5px]"
        *ngFor="let item of steps; let i = index"
        [ngStyle]="{ background: i < this.step ? '#7E9BD4' : i === this.step ? '#25508E' : '#DCDCDC' }"
      ></div>
    </div>
  </div>
  }

  <div class="mt-[42px] px-[60px] text-[#010B18] text-center font-open-sans text-[24px] font-bold leading-[36px]">{{ steps[step].stepLabel }}</div>

  <div style="padding: 0px 60px">
    @if(steps[step].stepType === 'member') {
    <div>
      <vault-setup-members
        [vaultMembers]="vaultMembers"
        [professionalVaultCreator]="professionalVaultCreator"
        (setVaultMember)="setVaultMember($event)"
        [isFromVault]="true"
      ></vault-setup-members>
    </div>
    } @if(steps[step].stepType === 'admin') {
    <div>
      <vault-setup-admin
        [vaultAdmins]="vaultAdmins"
        (setVaultAdmins)="setVaultAdmins($event)"
        [isFromVault]="true"
        [stepInfo]="stepInfo"
        [selectedIndex]="selectedIndex"
        [selectedVaultType]="selectedVaultTypeInfo"
      ></vault-setup-admin>
    </div>
    } @if(steps[step].stepType === 'sharing') {
    <div>
      <vault-setup-sharing
        [vaultSharing]="vaultSharing"
        (setVaultSharing)="setVaultSharing($event)"
        [isFromVault]="true"
        [stepInfo]="stepInfo"
        [selectedIndex]="selectedIndex"
        [selectedVaultType]="selectedVaultTypeInfo"
      ></vault-setup-sharing>
    </div>
    } @if(steps[step].stepType === 'name') {
    <add-entity-vault
      [forms]="forms"
      [isFromVault]="true"
      [setEntityTypeSuggestion]="setEntityTypeSuggestion"
      [setEntityNameSuggestion]="setEntityNameSuggestion"
      (setEntityType)="setEntityType($event)"
      (setEntityName)="setEntityName($event)"
    ></add-entity-vault>
    }
  </div>

  <div class="absolute h-[66px] w-[687px] bottom-[24px] ml-[32px] border-t border-[#C1C2C5] pt-[24px]">
    <div
      class="w-full flex"
      [ngClass]="{
        'justify-between': step > 0,
        'justify-end': step == 0
      }"
    >
      <button
        *ngIf="step > 0"
        type="button"
        class="flex justify-center items-center gap-[8px] px-[16px] py-[10px] rounded-[4px] bg-transparent text-[#18191C] text-center font-open-sans text-[14px] font-semibold leading-normal tracking-[0.07px]"
        (click)="changeStep(-1)"
      >
        <i class="material-icons back-arrow h-[16px] w-[16px] text-[16px]">arrow_back</i> Back
      </button>
      <button
        class="app__small__primary__button cy-vault-next-btn"
        [ngClass]="{
          'mt-3': selectedVaultType === 'entity' && (!entityName || !selectedEntityType)
        }"
        [class.app__small__primary__disabled]="this.selectedVaultType === 'entity' && (!entityName || !selectedEntityType)"
        [disabled]="this.selectedVaultType === 'entity' && (!entityName || !selectedEntityType)"
        (click)="changeStep(1)"
      >
        {{ is_entity_creation_suggestion ? 'Save' : 'Continue' }}
      </button>
    </div>
  </div>
</div>
@if (formData?.length) {
<div style="display: none">
  <edit-template-basic-form [Form1]="formData" [documentForm]="documentForm"> </edit-template-basic-form>
</div>
} }
